"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebGamepadDeviceManager = void 0;
const Logging_1 = require("../../../core/Logging");
const events_1 = require("events");
const WebGamepadDevice_1 = require("./WebGamepadDevice");
const WebGamepadProtocol_1 = require("../../../devices/protocols/WebGamepadProtocol");
const ButtplugDevice_1 = require("../../../devices/ButtplugDevice");
class WebGamepadDeviceManager extends events_1.EventEmitter {
    constructor(aLogger) {
        super();
        this._connectedGamepads = [];
        this.SetLogger(aLogger !== undefined ? aLogger : Logging_1.ButtplugLogger.Logger);
        window.addEventListener("gamepadconnected", (ev) => {
            console.log(`Gamepad connected`);
            console.log(ev.gamepad);
            this._connectedGamepads.push(ev.gamepad);
        });
        window.addEventListener("gamepaddisconnected", (ev) => {
            console.log(`Gamepad disconnected ${ev.gamepad}`);
            if (this._connectedGamepads.includes(ev.gamepad)) {
                this._connectedGamepads.splice(this._connectedGamepads.indexOf(ev.gamepad), 1);
            }
        });
    }
    SetLogger(aLogger) {
        this._logger = aLogger;
    }
    StartScanning() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const g of this._connectedGamepads) {
                // Remove the gamepad from the queue and add it to the emitted array.
                // Emit a new gamepad device.
                const webGamepadDevice = new WebGamepadDevice_1.WebGamepadDevice(g);
                const webGamepadProtocol = new WebGamepadProtocol_1.WebGamepadProtocol(webGamepadDevice);
                const device = new ButtplugDevice_1.ButtplugDevice(webGamepadProtocol, webGamepadDevice);
                this.emit("deviceadded", device);
            }
            // Clear the gamepad array so we don't double emit.
            this._connectedGamepads = [];
            this.emit("scanningfinished");
        });
    }
    StopScanning() {
        // noop. We only scan once then call it done.
    }
    get IsScanning() {
        // noop.
        return false;
    }
}
exports.WebGamepadDeviceManager = WebGamepadDeviceManager;
//# sourceMappingURL=WebGamepadDeviceManager.js.map